import React, { useEffect, useState } from 'react';
import BorrowerDataChangeFormSC, {
  BorrowerDataChangeFormErrorSC,
} from './borrower-data-change-form.styled';
import { Formik } from 'formik';
import IbanFormSchema from './borrower-data-change-form-rules';
import { HeadingTwo, SmallText } from '../../typography';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import Button from '../../ui/button';
import Checkbox from '../../ui/checkbox/checkbox';
import { ReactComponent as CheckIcon } from '../../../assets/img/svg/profile/check.svg';

const BorrowerDataChangeForm = ({ onSubmitForm, userData }) => {
  const [formInitialValues, setFormInitialValues] = useState({
    marketing_personal_data_consent: false,
  });

  useEffect(() => {
    if (Object.keys(userData).length > 1) {
      setFormInitialValues({
        marketing_personal_data_consent: userData.marketing_personal_data_consent
          ? userData.marketing_personal_data_consent
          : false,
      });
    }
  }, [userData]);

  return (
    <BorrowerDataChangeFormSC>
      <Formik
        enableReinitialize
        initialValues={formInitialValues}
        validationSchema={IbanFormSchema}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          const formattedValues = {
            marketing_personal_data_consent: values.marketing_personal_data_consent,
          };
          onSubmitForm(formattedValues);
        }}
      >
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => {
          const marketingPersonalDataHasError =
            errors &&
            errors.marketing_personal_data_consent &&
            touched.marketing_personal_data_consent;

          return (
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="top-text-wrap">
                  <HeadingTwo className="bold">
                    <FormattedHTMLMessage
                      id="profile_agreements_change_form_title"
                      defaultMessage={dlt['profile_agreements_change_form_title']}
                    />
                  </HeadingTwo>
                </div>

                <div className="full-block-disabled">
                  <div className="check-wrap">
                    {userData.personal_data_consent ? <CheckIcon /> : null}
                  </div>
                  <div className="text-wrap">
                    <SmallText className="uppercase bold gray">
                      <FormattedHTMLMessage
                        id="profile_approvals_first_headline"
                        defaultMessage={dlt['profile_approvals_first_headline']}
                      />{' '}
                      <span className="required">
                        <FormattedHTMLMessage
                          id="profile_approvals_required"
                          defaultMessage={dlt['profile_approvals_required']}
                        />
                      </span>
                    </SmallText>
                  </div>
                </div>

                <div className="full-block">
                  <Checkbox
                    name="marketing_personal_data_consent"
                    hasError={marketingPersonalDataHasError}
                    value={`${values.marketing_personal_data_consent}`}
                    checked={values.marketing_personal_data_consent || false}
                    onChange={handleChange}
                    label="profile_approvals_second_headline"
                  />
                  {marketingPersonalDataHasError ? (
                    <BorrowerDataChangeFormErrorSC>
                      {errors.marketing_personal_data_consent}
                    </BorrowerDataChangeFormErrorSC>
                  ) : null}
                </div>
              </div>

              <div className="row">
                <div className="full-block">
                  {/*    <BiggerText>
                    <FormattedMessage
                      id="requests_form_continue_hint"
                      defaultMessage={dlt['requests_form_continue_hint']}
                    />
                  </BiggerText> */}
                  <Button type="PRIMARY" className="form-submit" onClick={handleSubmit} withIcon>
                    <FormattedMessage
                      id="global_continue"
                      defaultMessage={dlt['global_continue']}
                    />
                  </Button>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    </BorrowerDataChangeFormSC>
  );
};

export default BorrowerDataChangeForm;
